export enum StorageBucket {
  Application = "application",
  Users = "users",
  Companies = "companies",
  Projects = "projects",
}

enum ApplicationFileName {
  ShowspaceLogo = "showspace-logo-300.png",
  ProjectPlaceholderImage = "placeholder-image.webp",
  PortfolioInsights = "showspace-insights.png",
  ShowspaceExamplePortfolioProjects = "social-showspace-portfolio.jpg",
  ShowspaceExamplePortfolio = "showspace-portfolio-social-3-9-23.jpg",
  DefaultPortfolioCover = "default-portfolio-cover-abstract-blue.jpg",
}

enum ApplicationUrlType {
  Root = "root_do-not-use",
  Blog = "blog",
  Resources = "resources",
}

interface UrlPath {
  type: StorageBucket;
}

export interface ApplicationRootUrlPath extends UrlPath {
  type: StorageBucket.Application;
  subPathType: ApplicationUrlType.Root;
  fileName: ApplicationFileName;
}

export interface ApplicationBlogUrlPath extends UrlPath {
  type: StorageBucket.Application;
  subPathType: ApplicationUrlType.Blog;
  fileName: "braintrust-email.png" | "braintrust-response.png";
}

export interface ApplicationResourcesUrlPath extends UrlPath {
  type: StorageBucket.Application;
  subPathType: ApplicationUrlType.Resources;
  fileName:
    | "sixty-on-demand-project-example.png"
    | "staynom-project-example.png"
    | "smv-project-example.png";
}

type ApplicationUrlPath =
  | ApplicationRootUrlPath
  | ApplicationBlogUrlPath
  | ApplicationResourcesUrlPath;

export interface UserUrlPath extends UrlPath {
  type: StorageBucket.Users;
  userId: string;
  avatarFileName?: string;
}

export interface ProjectUrlPath extends UrlPath {
  type: StorageBucket.Projects;
  // TODO | Confirm that field is required
  thumbnailFileName: string;
}

export interface CompanyUrlPath extends UrlPath {
  type: StorageBucket.Companies;
  companyId: string;
  // TODO | Confirm that field is required
  coverImageFileName: string;
}

type StorageUrlPathMap = {
  [StorageBucket.Application]: ApplicationUrlPath;
  [StorageBucket.Users]: UserUrlPath;
  [StorageBucket.Companies]: CompanyUrlPath;
  [StorageBucket.Projects]: ProjectUrlPath;
};

export function constructStorageUrl(
  urlPath: StorageUrlPathMap[StorageBucket]
): string | undefined {
  // TODO | Replace the domain with an environment variable to support dev / staging environments
  const baseUrl =
    "https://chmqmeyyaiwfybqgcdoy.supabase.co/storage/v1/object/public";
  let urlSuffix: string;

  switch (urlPath.type) {
    case StorageBucket.Application:
      switch (urlPath.subPathType) {
        case ApplicationUrlType.Root:
          urlSuffix = urlPath.fileName;
          break;
        case ApplicationUrlType.Blog:
          urlSuffix = `blog/${urlPath.fileName}`;
          break;
        case ApplicationUrlType.Resources:
          urlSuffix = `resources/${urlPath.fileName}`;
          break;
        default:
          throw new Error(
            `Invalid ApplicationUrlType in urlPath: ${JSON.stringify(urlPath)}`
          );
      }
      break;
    case StorageBucket.Users:
      if (urlPath.avatarFileName === null) {
        return undefined;
      }
      urlSuffix = `${urlPath.userId}/${urlPath.avatarFileName}`;
      break;
    case StorageBucket.Projects:
      urlSuffix = urlPath.thumbnailFileName;
      break;
    case StorageBucket.Companies:
      urlSuffix = `${urlPath.companyId}/${urlPath.coverImageFileName}`;
      break;
    default:
      throw new Error(
        `Invalid StorageBucket in urlPath: ${JSON.stringify(urlPath)}`
      );
  }

  return `${baseUrl}/${urlPath.type}/${urlSuffix}`;
}
